import Layout from '../../internal/Layout.vue'
import TasksPage from './tasks.vue'

const TasksRoutes = {
  component: Layout,
  children: [
    {
      name: 'task',
      path: '/',
      component: TasksPage,
      meta: {
        module: 'tarefas',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default TasksRoutes
